(function () {
  const HULK_IFRAME_PATTERN = /hulkapps\.com/i;

  function getDemoSku() {
    return new URLSearchParams(window.location.search).get('demo-sku');
  }

  // Hulk advance_js reads rental-sku from referrer_url; inject it there only (not the page URL).
  function patchHulkIframe(iframe) {
    const rawSrc = iframe.getAttribute('src');
    const sku = getDemoSku();

    if (!rawSrc || !sku || !HULK_IFRAME_PATTERN.test(rawSrc)) {
      return false;
    }

    try {
      const iframeUrl = new URL(rawSrc, window.location.origin);
      const referrerUrl = iframeUrl.searchParams.get('referrer_url');

      if (!referrerUrl) {
        return false;
      }

      const referrer = new URL(referrerUrl);

      if (referrer.searchParams.get('rental-sku')) {
        return false;
      }

      referrer.searchParams.set('rental-sku', sku);
      iframeUrl.searchParams.set('referrer_url', referrer.toString());
      iframe.setAttribute('src', iframeUrl.toString());
      return true;
    } catch (error) {
      return false;
    }
  }

  function patchAllHulkIframes() {
    document.querySelectorAll('iframe').forEach(patchHulkIframe);
  }

  function init() {
    patchAllHulkIframes();

    const observer = new MutationObserver(patchAllHulkIframes);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src'],
    });

    window.setTimeout(() => observer.disconnect(), 30000);
  }

  init();
})();
